"use client";
import React from "react";
import styles from "./ai-mastering-page.module.scss";
import FilledButton from "@/components/common/filled-button";
import UnfilledButton from "@/components/common/unfilled-button";
import { useAiMastering } from "@/components/pages/ai-mastering/providers/ai-mastering-provider";
import MasteringOptionsHeader from "@/components/pages/ai-mastering/components/mastering-options-header";
import MasteringPresetTab from "@/components/pages/ai-mastering/components/mastering-preset-tab";
import MasteringReferenceTab from "@/components/pages/ai-mastering/components/mastering-reference-tab";
import TargetTrackContainer from "@/components/pages/ai-mastering/components/target-track-container";
import MasteringResult from "@/components/pages/ai-mastering/components/mastering-result";
import ServicePageHeader from "@/components/common/service-page-header";
import style from "@/components/pages/custom/custom-page.module.scss";
import Link from "next/link";
import HelpFixedButton from "@/components/common/help-fixed-button";
import { useMasteringProgressContext } from "@/components/pages/ai-mastering/hooks/mastering-progress-provider";
import {
  shouldDisplayProgress,
  shouldDisplayStartProcessButton,
} from "@/hooks/progress-context/use-anonymous-progress-provider";
import ProgressBar from "@/components/pages/convert/components/progress-bar";

const AiMasteringPage = () => {
  const { isValid, reset, master, masteredTrack } = useAiMastering();
  const { status, percent, description, isLoading } =
    useMasteringProgressContext();
  return (
    <div className={styles.overwrap}>
      <div className={styles.wrapper}>
        <ServicePageHeader
          title={
            <>
              AI <span>Mastering</span>
            </>
          }
          description={
            'Upload your track, select one of our presets or upload a reference track, and press "Master" to finalize your track.'
          }
        />
        <TargetTrackContainer />
        {shouldDisplayProgress(status) && !isLoading ? (
          <ProgressBar percent={percent} descriptionCode={description} />
        ) : (
          <MasteringResult />
        )}
        <div className={styles.container}>
          <p>Select mastering style</p>
          <div className={styles.mastering_style_tabs}>
            <MasteringOptionsHeader />
            <MasteringPresetTab />
            <MasteringReferenceTab />
          </div>
        </div>
        <div className={styles.buttons_container}>
          <UnfilledButton
            disabled={!isValid && !masteredTrack}
            text={"RESET"}
            onClick={reset}
          />
          <FilledButton
            disabled={!isValid || !shouldDisplayStartProcessButton(status)}
            text={"MASTER"}
            onClick={master}
          />
        </div>
        <HelpFixedButton href={"/how-to-use/ai-mastering-tips"} />
      </div>
    </div>
  );
};

export default AiMasteringPage;
